import React, { createContext, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import axiosClient from '../api/axiosClient';
import { useToasts } from './ToastContext';
import { useAuth } from './AuthContext';

const PROGRAM_ROLES = ['Program Director', 'Instructor', 'Program Coordinator'];

const ProgramContext = createContext();

export const useProgram = () => useContext(ProgramContext);

export const ProgramProvider = ({ children }) => {
  const [programs, setPrograms] = useState([]);
  const [selectedProgramId, setSelectedProgramId] = useState(null);
  const { showToast } = useToasts();
  const { role } = useAuth();

  useEffect(() => {
    if (!PROGRAM_ROLES.includes(role)) return;

    axiosClient.get('/programs')
      .then((response) => {
        const data = response.data?.programs || [];
        setPrograms(data);
        if (data.length > 0) {
          setSelectedProgramId((prev) => prev || data[0].id);
        }
      })
      .catch((error) => {
        showToast(error.message, 'error');
      });
  }, [role, showToast]);

  return (
    <ProgramContext.Provider value={{ programs, selectedProgramId, setSelectedProgramId }}>
      {children}
    </ProgramContext.Provider>
  );
};

ProgramProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
